(function () {
  try {
    if (window.__salepifyYmalKeeper) return;
    window.__salepifyYmalKeeper = true;

    var WIDGET = "salepify-ymal";
    var timer = null;
    var reinserting = false;
    var lastReinsert = 0;

    // Lấy id product đang xem: ưu tiên biến từ theme.liquid, fallback ShopifyAnalytics
    var PRODUCT_ID = (function () {
      try {
        if (window.SALEPIFY_YMAL_PRODUCT_ID) return String(window.SALEPIFY_YMAL_PRODUCT_ID);
        var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
        if (meta && meta.page && meta.page.pageType === "product" && meta.product && meta.product.id) {
          return String(meta.product.id);
        }
      } catch (e) {}
      return null;
    })();

    function getYmal() {
      try {
        var y = window.tlYMAL;
        return y && typeof y.checkApplyOffer === "function" ? y : null;
      } catch (e) { return null; }
    }

    // Trang product: điều kiện = product đang xem, không xét cart
    function patchProductPage(ymal) {
      try {
        if (!PRODUCT_ID || ymal.__productPatched) return;
        ymal.__productPatched = true;

        var originalCheckCartData = ymal.checkCartData;
        ymal.checkCartData = async function () {
          var addedMap = new Map();
          try {
            var result = await originalCheckCartData.apply(ymal, arguments);
            if (result && result.ruleIdMapAddedRecommendProd) addedMap = result.ruleIdMapAddedRecommendProd;
          } catch (e) {
            console.warn("[YMAL product] read cart error:", e);
          }
          return { productInCart: [PRODUCT_ID], ruleIdMapAddedRecommendProd: addedMap };
        };

        var originalBuildSelectors = ymal.buildSelectors;
        ymal.buildSelectors = function () {
          try {
            return ymal.getProductPageSelector();
          } catch (e) {
            return originalBuildSelectors.apply(ymal, arguments);
          }
        };

        ymal.checkApplyOffer();
      } catch (e) {
        console.warn("[YMAL product] patch error:", e);
      }
    }

    // Ép hiển thị khi widget có rule + nội dung nhưng bị theme CSS ẩn
    function forceVisible() {
      try {
        document.querySelectorAll(WIDGET).forEach(function (el) {
          try {
            if (!el.getAttribute("rule-id") || !el.children.length) return;
            if (window.getComputedStyle(el).display === "none" || el.hidden) {
              el.hidden = false;
              el.style.setProperty("display", "flex", "important");
            }
            el.style.setProperty("visibility", "visible", "important");
            el.style.setProperty("opacity", "1", "important");
          } catch (e) {}
        });
      } catch (e) {
        console.warn("[YMAL keeper] forceVisible error:", e);
      }
    }

    // Chèn lại widget nếu theme render lại và xoá mất
    function ensureWidget() {
      try {
        var ymal = getYmal();
        if (!ymal || reinserting || typeof ymal.reInsertWidget !== "function") return;

        var targets = ymal.getTargetElements();
        if (!targets || !targets.length) return;
        if (document.querySelectorAll(WIDGET + "[rule-id]").length) return;

        if (Date.now() - lastReinsert < 1000) return;
        lastReinsert = Date.now();
        reinserting = true;
        try {
          ymal.reInsertWidget();
        } finally {
          setTimeout(function () { reinserting = false; }, 300);
        }
      } catch (e) {
        reinserting = false;
        console.warn("[YMAL keeper] ensureWidget error:", e);
      }
    }

    function run() {
      try {
        ensureWidget();
        forceVisible();
      } catch (e) {}
    }

    function schedule() {
      try {
        clearTimeout(timer);
        timer = setTimeout(run, 250);
      } catch (e) {}
    }

    function start(ymal) {
      try {
        patchProductPage(ymal);
        run();
        if (typeof MutationObserver !== "undefined") {
          new MutationObserver(function () {
            try { if (!reinserting) schedule(); } catch (e) {}
          }).observe(document.body, { childList: true, subtree: true });
        }
        ["TLYAML:add", "TLYAML:change", "TLYAML:update"].forEach(function (evt) {
          window.addEventListener(evt, function () {
            try { setTimeout(run, 800); } catch (e) {}
          });
        });
      } catch (e) {
        console.warn("[YMAL keeper] start error:", e);
      }
    }

    // Đợi script YMAL của app load xong (tối đa 15s)
    var tries = 0;
    var waiter = setInterval(function () {
      try {
        var ymal = getYmal();
        if (ymal || ++tries > 75) {
          clearInterval(waiter);
          if (ymal) start(ymal);
        }
      } catch (e) {
        clearInterval(waiter);
      }
    }, 200);
  } catch (e) {
    console.warn("[YMAL keeper] fatal error:", e);
  }
})();
